<template>
  <!-- 错词列表模块  -->
  <div class="class-contrast">
    <!-- 对比数据 -->
    <div class="tea-search tea-search2 ">
      <div class="title0">数据对比</div>
      <div class="search-select-box">
        <!-- 对比1 -->
        <div class="search-select">
          <el-select v-model="contrast_model1.bjid" placeholder="请选择班级" size="small" @change="handelClassChange(1)">
            <el-option v-for="item in class_options" :key="item.bjid" :label="item.bjmc" :value="item.bjid">
            </el-option>
          </el-select>
          <el-select v-model="contrast_model1.jxid" placeholder="请选择集训" size="small" @change="handelTrainChange(1)">
            <el-option v-for="item in train_options1" :key="item.jxid" :label="item.jxmc" :value="item.jxid">
            </el-option>
          </el-select>
          <el-select v-model="contrast_model1.xzid" placeholder="请选择小组" size="small" style="width:360px">
            <el-option v-for="item in group_options1" :key="item.id" :label="item.name+'('+new Date(item.sksj).Format('yyyy-MM-dd hh:mm:ss')+'-'+new Date(item.xksj).Format('yyyy-MM-dd hh:mm:ss')+')'" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!-- 对比2 -->
        <div class="search-select">
          <el-select v-model="contrast_model2.bjid" placeholder="请选择班级" size="small" @change="handelClassChange(2)">
            <el-option v-for="item in class_options" :key="item.bjid" :label="item.bjmc" :value="item.bjid">
            </el-option>
          </el-select>
          <el-select v-model="contrast_model2.jxid" placeholder="请选择集训" size="small" @change="handelTrainChange(2)">
            <el-option v-for="item in train_options2" :key="item.jxid" :label="item.jxmc" :value="item.jxid">
            </el-option>
          </el-select>
          <el-select v-model="contrast_model2.xzid" placeholder="请选择小组" size="small" style="width:360px">
            <el-option v-for="item in group_options2" :key="item.id" :label="item.name+'('+new Date(item.sksj).Format('yyyy-MM-dd hh:mm:ss')+'-'+new Date(item.xksj).Format('yyyy-MM-dd hh:mm:ss')+')'" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!--  -->
      </div>
      <div class="search-submit">
        <el-button size="small" icon="el-icon-search" type="primary" class="fr tea-btn" @click="handelSearch()">对 比</el-button>
      </div>
    </div>
    <!-- 分析结果 -->
    <div class="data-result" v-show="is_empty==false">
      <div class="title0">分析结果</div>
      <div class="result-box">
        <div class="total-result">
          <!-- height="calc(100% - 50px)" -->
          <el-table :data="tableData1" border style="width: 100%">
            <el-table-column label="序号" type="index" width="60">
              <template slot-scope="scope">
                <span>{{scope.$index+1}}</span>
              </template>
            </el-table-column>
            <el-table-column label="班级名称" prop="bjmc">
            </el-table-column>
            <el-table-column label="集训名称" prop="jxmc">
            </el-table-column>
            <el-table-column label="小组名称" prop="xzmc">
            </el-table-column>
            <el-table-column label="小组人数" prop="personCount" width="">
            </el-table-column>
            <el-table-column label="学习时间" prop="index" width="330">
              <template slot-scope="scope">
                <span>{{new Date(scope.row.yxqq).Format("yyyy-MM-dd hh:mm:ss")}}</span>
                至
                <span>{{new Date(scope.row.yxqz).Format("yyyy-MM-dd hh:mm:ss")}}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 掌握情况分析 -->
        <div class="master-result">
          <div class="title1">掌握情况分析：</div>
          <!-- height="calc(100% - 50px)" -->
          <div class="total-result">
            <el-table :data="tableData" border style="width: 100%">
              <el-table-column label="班级名称" prop="bjmc">
              </el-table-column>
              <el-table-column label="集训名称" prop="jxmc">
              </el-table-column>
              <el-table-column label="小组名称" prop="xzmc">
              </el-table-column>
              <el-table-column label="已学单词（平均）" prop="yxdc">
              </el-table-column>
              <el-table-column label="已掌握单词（平均）" prop="yzwdc">
              </el-table-column>
              <el-table-column label="未掌握单词（平均）" prop="wzwdc">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <!-- 学情分析 -->
      <div class="master-result">
        <div class="title1">学情分析：</div>
        <div class="radar-contain">
          <!-- 饼图 -->
          <div class="radar" id="radar"></div>
          <el-table :data="tableData" border class="table">
            <el-table-column label="班级名称" prop="bjmc">
            </el-table-column>
            <el-table-column label="集训名称" prop="jxmc">
            </el-table-column>
            <el-table-column label="小组名称" prop="xzmc">
            </el-table-column>
            <el-table-column label="综合（平均）" prop="fs">
            </el-table-column>
            <el-table-column label="看义选英（平均）" prop="zwxy">
            </el-table-column>
            <el-table-column label="看义拼词（平均）" prop="kypc">
            </el-table-column>
            <el-table-column label="听音辨英（平均）" prop="tyby">
            </el-table-column>
            <el-table-column label="看英选义（平均）" prop="kyxy">
            </el-table-column>
          </el-table>
        </div>
        <!-- 俩柱状图 -->
        <div class="vertical-box">
          <div id="vertical1"></div>
          <div id="vertical2"></div>
        </div>
      </div>
    </div>
    <div class="data-result" v-show="is_empty==true">
      <el-empty description="暂无数据" class="empty"></el-empty>
    </div>
  </div>
</template>
<script>
import {
  analysisClassOptionsApi,//班级下拉
  analysisTrainOptionsApi,//集训下拉
  analysisGroupOptionsApi,//小组下拉
  analysisStudentOptionsApi,// 学生下拉
  analysisClassContrastApi,// 班级对比
  analysisGroupContrastApi,// 小组对比
  analysisStudentContrastApi// 学生对比
} from '@/api/teacher'
import {
  getCoinsList,//金币明细
} from '@/api/student'
import * as echarts from 'echarts';
import Vue from "vue";
Vue.use(echarts);
import {
  BarChart
} from 'echarts/charts';
// 引入提示框，标题，直角坐标系组件，组件后缀都为 Component
import {
  TitleComponent,
  TooltipComponent,
  GridComponent
} from 'echarts/components';
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import {
  CanvasRenderer
} from 'echarts/renderers';
// 注册必须的组件
echarts.use(
  [TitleComponent, TooltipComponent, GridComponent, BarChart, CanvasRenderer]
);
var name_list = []
export default {
  data() {
    return {
      is_empty: true,
      yhid: this.$store.state.userInfo.yhid,
      zhid: this.$store.state.userInfo.zhid,
      bjlx: this.$route.query.lx,
      bjid: this.$route.query.bjid,
      bjmc: this.$route.query.bjmc,
      contrast_model1: {
        bjid: null, jxid: null, xzid: null, yxqq: null, yxqz: null,
      },
      contrast_model2: {
        bjid: null, jxid: null, xzid: null, yxqq: null, yxqz: null,
      },
      // 班级下拉
      class_options: [],
      // 集训下拉
      train_options1: [],
      train_options2: [],
      // 小组下拉
      group_options1: [],
      group_options2: [],
      // 数据展示
      tableData: [],
      tableData1: [],
      // 雷达图配置
      radarOption: {
        radar: {
          indicator: [
            { name: '综合', max: 100 },
            { name: '看义选英', max: 100 },
            { name: '看义拼词', max: 100 },
            { name: '听音辨英', max: 100 },
            { name: '看英选义', max: 100 },
          ],
          name: {
            padding: [-10, -10, -10, -10],
            fontSize: '12',
            color: '#333'

          }
        },
        tooltip: {
          formatter: function (params) {
            return `综合:${params.value[0] ? params.value[0] : 0}<br />看义选英:${params.value[1] ? params.value[1] : 0}<br />看义拼词:${params.value[2] ? params.value[2] : 0}<br />听音辨英:${params.value[3] ? params.value[3] : 0}<br /> 看英选义:${params.value[4] ? params.value[4] : 0}`
          }
        },
        legend: {
          x: 'center',      //可设定图例在左、右、居中
          y: 'bottom',
        },
        series: [{
          name: '题型得分率分析',
          type: 'radar',
          areaStyle: {
            color: 'rgba(0, 0, 0, 0)'
          },
          data: []
        }]
      },
      // 柱状图1
      vertical1_options: {
        grid: {
          left: '100px',
          right: '0',
          bottom: '50px',
          containLabel: true,
        },
        // 图例
        legend: {
          orient: 'horizontal',
          x: 'center',      //可设定图例在左、右、居中
          y: 'bottom',  //可设定图例在上、下、居中
          formatter: function (name) {
            const show_text = name == 'name1' ? name_list[0] : name == 'name2' ? name_list[1] : ''
            return show_text
          },
          data: ['product', 'name1', 'name2']
        },
        // 滑动显示工具栏
        tooltip: {
          trigger: 'axis',
          formatter: function (val, value) {
            const v = val[0].data
            const text =
              "<span style='font-weight:600;color:#666;line-height:30px'>" + v.product + "</span>" + "<br/>"
              + "<span style='color:#39A0FF'>" + name_list[0] + "</span>" + "&nbsp;&nbsp;&nbsp;&nbsp;" + v.name1.toFixed(2) + "%" + "<br/>"
              + "<span style='color:#4ECB73'>" + name_list[1] + "</span>" + "&nbsp;&nbsp;&nbsp;&nbsp;" + v.name2.toFixed(2) + "%" + "<br/>"
            return text;
          },
          shadowColor: "#E4E7ED",
        },
        color: ["#39A0FF", "#4ECB73",],
        dataset: {
          source: []
        },
        xAxis: { type: 'category', boundaryGap: true },
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              show: true,
              interval: 'auto',
              // formatter: function (name) {
              //   console.log(name)
              //   return name+'%'
              //   // console.log(name)
              // }
              formatter: '{value} %',
              // console.log(name)
            },
            show: true,
          }
        ],
        series: [
          {
            type: 'bar',
            label: {
              normal: {
                show: true,
                position: 'top',
                textStyle: {
                  fontSize: '0.6rem',
                  color: '#333'
                },
                formatter: function (val) {
                  // return val.data.shcsl;
                  return val.data.name1 ? val.data.name1.toFixed(2) + '%' : '';
                },
                color: '#000',

              },

            },
            barWidth: 30,
          },
          {
            type: 'bar',
            label: {
              normal: {
                show: true,
                position: 'top',
                textStyle: {
                  fontSize: '0.6rem',
                  color: '#333'
                },
                formatter: function (val) {
                  // return val.data.jscsl;
                  return val.data.name2 ? val.data.name2.toFixed(2) + '%' : '';
                },
              }
            },
            barWidth: 30,
          },
        ],
      },
      vertical2_options: {
        grid: {
          left: '100px',
          right: '0',
          bottom: '50px',
          containLabel: true,
        },
        // 图例
        legend: {
          orient: 'horizontal',
          x: 'center',      //可设定图例在左、右、居中
          y: 'bottom',
          // padding: ['80', '10'],    //可设定图例在上、下、居中
          formatter: function (name) {
            const show_text = name == 'name1' ? name_list[0] : name == 'name2' ? name_list[1] : ''
            return show_text
          },
          data: ['product', 'name1', 'name2',]
        },
        // 滑动显示工具栏
        tooltip: {
          trigger: 'axis',
          formatter: function (val, value, opop) {
            const v = val[0].data
            const text =

              "<span style='font-weight:600;color:#666;line-height:30px'>" + v.product + "</span>" + "<br/>"
              + "<span style='color:#39A0FF'>" + name_list[0] + "</span>" + "&nbsp;&nbsp;&nbsp;&nbsp;" + v.name1.toFixed(2) + "%" + "<br/>"
              + "<span style='color:#4ECB73'>" + name_list[1] + "</span>" + "&nbsp;&nbsp;&nbsp;&nbsp;" + v.name2.toFixed(2) + "%" + "<br/>"
            return text;
          },
          shadowColor: "#E4E7ED",
        },
        color: ["#39A0FF", "#4ECB73",],
        dataset: {
          source: []
        },
        xAxis: { type: 'category', boundaryGap: true },
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              show: true,
              interval: 'auto',
              formatter: '{value} %',
            },
            show: true,
          }
        ],
        series: [
          {
            type: 'bar',
            label: {
              normal: {
                show: true,
                position: 'top',
                textStyle: {
                  fontSize: '0.6rem',
                  color: '#333'
                },
                formatter: function (val) {
                  // return val.data.shcsl;
                  return val.data.name1 ? val.data.name1.toFixed(2) + '%' : '';
                },
                color: '#000',

              },

            },
            barWidth: 30,
          },
          {
            type: 'bar',
            label: {
              normal: {
                show: true,
                position: 'top',
                textStyle: {
                  fontSize: '0.6rem',
                  color: '#333'
                },
                formatter: function (val) {
                  return val.data.name2 ? val.data.name2.toFixed(2) + '%' : '';
                },
              }
            },
            barWidth: 30,
          },
        ]
      },
      // 柱状图2
    }
  },
  created() {

  },
  mounted() {
    // 班级下拉
    this.getClassOptions();
  },
  methods: {
    // 获取班级下拉
    getClassOptions() {
      const data = {
        jsid: this.yhid,
        yhid: this.yhid,
      }
      analysisClassOptionsApi(data).then(res => {
        if (res.success) {
          this.class_options = res.result
          // bjid 257
          console.log(res.result)
        } else {
          this.$message.error(res.resultDesc)
        }
      })
    },
    // 集训下拉
    getTrainOptions(val) {
      const data = {
        yhid: this.yhid,
        bjid: null,
      }
      if (val == 1) {
        data.bjid = this.contrast_model1.bjid
      } else if (val == 2) {
        data.bjid = this.contrast_model2.bjid
      }
      analysisTrainOptionsApi(data).then(res => {
        if (res.success) {
          if (val == 1) {
            this.train_options1 = res.result
          } else if (val == 2) {
            this.train_options2 = res.result
          }
          console.log(res.result)
        } else {
          this.$message.error(res.resultDesc)
        }
      })
    },
    // 小组下拉
    getGroupOptions(val) {
      const data = {
        yhid: this.yhid,
        // bjid: 257,
        // jxid: 390,
      }
      if (val == 1) {
        data.bjid = this.contrast_model1.bjid;
        data.jxid = this.contrast_model1.jxid;
        console.log(this.contrast_model1)
        data.sksj = this.contrast_model1.yxqq
        data.xksj = this.contrast_model1.yxqz
      } else if (val == 2) {
        console.log(this.train_options2)
        data.bjid = this.contrast_model2.bjid;
        data.jxid = this.contrast_model2.jxid;
        data.sksj = this.contrast_model2.yxqq
        data.xksj = this.contrast_model2.yxqz
      }
      console.log(data)
      analysisGroupOptionsApi(data).then(res => {
        if (res.success) {
          if (val == 1) {
            this.group_options1 = res.result
          } else if (val == 2) {
            this.group_options2 = res.result
          }
          console.log(res.result)
        } else {
          this.$message.error(res.resultDesc)
        }
      })
    },
    // 班级下拉选择
    handelClassChange(val) {
      if (val == 1) {
        this.contrast_model1.jxid = null;
        this.contrast_model1.xzid = null;
        this.contrast_model1.yxqq = null;
        this.contrast_model1.yxqz = null;
      } else if (val == 2) {
        this.contrast_model2.jxid = null;
        this.contrast_model2.xzid = null;
        this.contrast_model2.yxqq = null;
        this.contrast_model2.yxqz = null;
      }
      console.log()
      this.getTrainOptions(val)
    },
    // 集训下拉选择改变
    handelTrainChange(val) {
      if (val == 1) {
        this.contrast_model1.xzid = null;
        const result = this.train_options1.find((item) => {
          return item.jxid == this.contrast_model1.jxid;
        })
        this.contrast_model1.yxqq = result.yxqq;
        this.contrast_model1.yxqz = result.yxqz;
        console.log(result)
      } else if (val == 2) {
        this.contrast_model2.xzid = null;
        const result = this.train_options2.find((item) => {
          return item.jxid == this.contrast_model2.jxid;
        })
        this.contrast_model2.yxqq = result.yxqq;
        this.contrast_model2.yxqz = result.yxqz;
      }
      this.getGroupOptions(val)
    },
    // 点击分析
    handelSearch() {
      if ((!this.contrast_model1.xzid) || (!this.contrast_model2.xzid)) {
        this.$message.error('请先选择小组')
        return false
      }
      this.getTabelList()
      this.getGroupContrastResult();
    },
    // 小组对比
    getGroupContrastResult() {
      const data1 = JSON.parse(JSON.stringify(this.contrast_model1))
      const data2 = JSON.parse(JSON.stringify(this.contrast_model2))
      delete data1.yxqq;
      delete data1.yxqz;
      delete data2.yxqq;
      delete data2.yxqz;
      const data = {
        conparisonReqList: [
          data1, data2
        ],
      }
      analysisGroupContrastApi(data).then(res => {
        this.is_empty = false
        this.tableData = JSON.parse(JSON.stringify(res.result));
        console.log(this.tableData)
        this.tableData.push({
          bjmc: '差异',
          jxmc: '无', xzmc: '无',
          yxdc: Math.abs(this.tableData[0].yxdc - this.tableData[1].yxdc),
          yzwdc: Math.abs(this.tableData[0].yzwdc - this.tableData[1].yzwdc),
          wzwdc: Math.abs(this.tableData[0].wzwdc - this.tableData[1].wzwdc),
          // 
          fs: Math.abs(this.tableData[0].fs - this.tableData[1].fs),
          zwxy: Math.abs(this.tableData[0].zwxy - this.tableData[1].zwxy),
          tyby: Math.abs(this.tableData[0].tyby - this.tableData[1].tyby),
          kyxy: Math.abs(this.tableData[0].kyxy - this.tableData[1].kyxy),
          kypc: Math.abs(this.tableData[0].kypc - this.tableData[1].kypc),
        })
        name_list = [res.result[0].xzmc, res.result[1].xzmc,]
        // 雷达图初始化数据
        let radar0 = [
          res.result[0].fs,
          res.result[0].zwxy,
          res.result[0].kypc,
          res.result[0].tyby,
          res.result[0].kyxy,
        ]
        let radar1 = [
          res.result[1].fs,
          res.result[1].zwxy,
          res.result[1].kypc,
          res.result[1].tyby,
          res.result[1].kyxy,
        ]
        this.radarOption.series[0].data = [
          {
            value: radar0,
            name: res.result[0].xzmc
          },
          {
            value: radar1,
            name: res.result[1].xzmc

          },
        ]
        console.log(this.radarOption.series.data)
        this.setradarInit()
        // 第一个柱状图数据初始化
        const barData1 = [
          {
            product: '熟词',
            name1: res.result[0].sucl * 100,
            name2: res.result[1].sucl * 100,
          },
          {
            product: '夹生词',
            name1: res.result[0].jscl * 100,
            name2: res.result[1].jscl * 100,
          },
          {
            product: '生词',
            name1: res.result[0].shcl * 100,
            name2: res.result[1].shcl * 100,
          },
        ]
        this.vertical1_options.dataset.source = barData1;
        this.vertical1Init()
        // 第二个柱状图初始化
        const barData2 = [
          {
            product: '三星通过',
            name1: res.result[0].threexjl * 100,
            name2: res.result[1].threexjl * 100,
          },
          {
            product: '二星通过',
            name1: res.result[0].twoxjl * 100,
            name2: res.result[1].twoxjl * 100,
          },
          {
            product: '一星通过',
            name1: res.result[0].onexjl * 100,
            name2: res.result[1].onexjl * 100,
          },
          {
            product: '未通过',
            name1: res.result[0].noxjl * 100,
            name2: res.result[1].noxjl * 100,
          },
        ]
        this.vertical2_options.dataset.source = barData2;
        this.vertical2Init()
        console.log(res.result)
      })
    },
    // 进行第一个列表的自主计算数据
    getTabelList() {
      const result1 = {};
      // 班级名称
      const class_result1 = this.class_options.find(m => {
        return m.bjid == this.contrast_model1.bjid
      })
      result1.bjmc = class_result1.bjmc;
      // 集训名称 学习时间
      const train_result1 = this.train_options1.find(m => {
        return m.jxid == this.contrast_model1.jxid
      })
      result1.jxmc = train_result1.jxmc;

      // 小组名称  小组人数
      const group_result1 = this.group_options1.find(m => {
        return m.id == this.contrast_model1.xzid
      })
      result1.xzmc = group_result1.name;
      result1.yxqq = group_result1.sksj;
      result1.yxqz = group_result1.xksj;
      result1.personCount = group_result1.groupStudent;
      // ------------------------------
      const result2 = {};
      // 班级名称
      const class_result2 = this.class_options.find(m => {
        return m.bjid == this.contrast_model2.bjid
      })
      result2.bjmc = class_result2.bjmc;
      // 集训名称 学习时间
      const train_result2 = this.train_options2.find(m => {
        return m.jxid == this.contrast_model2.jxid
      })
      result2.jxmc = train_result2.jxmc;

      // 小组名称 小组人数
      const group_result2 = this.group_options2.find(m => {
        return m.id == this.contrast_model2.xzid
      })
      result2.xzmc = group_result2.name;
      result2.yxqq = group_result2.sksj;
      result2.yxqz = group_result2.xksj;
      result2.personCount = group_result2.groupStudent;
      this.tableData1 = [result1, result2];
      console.log(this.tableData1)
    },
    setradarInit() {
      const myEcharts = echarts.init(document.getElementById('radar'))
      myEcharts.setOption(this.radarOption)
      window.addEventListener("resize", function () {
        myEcharts.resize();
      });
    },
    vertical1Init() {
      const myEcharts = echarts.init(document.getElementById('vertical1'))
      myEcharts.setOption(this.vertical1_options)
      window.addEventListener("resize", function () {
        myEcharts.resize();
      });
    },
    vertical2Init() {
      const myEcharts = echarts.init(document.getElementById('vertical2'))
      myEcharts.setOption(this.vertical2_options)
      window.addEventListener("resize", function () {
        myEcharts.resize();
      });
    },
  }
}
</script>
<style lang="scss" scoped>
.class-contrast {
  height: 100%;
}
.tea-search2 {
  width: 100%;
  display: flex;
  padding-top: 10px;
  align-items: center;
}
.search-select-box {
}
.search-select {
  margin: 15px 0;
  .el-select {
    margin-left: 15px;
  }
}
.search-submit {
  margin-left: 20px;
  // margin-top: 15px;
}
.title0 {
  color: #5186c2;
  font-size: 18px;
  font-weight: 600;
  margin: 0 20px;
}
.data-result {
  width: 100%;
  padding: 10px;
  height: calc(100% - 150px);
  overflow-y: scroll;
  border-top: #eee solid 1px;
  margin-top: 10px;
  // position: relative;
  ::v-deep .empty {
    width: 100%;
    height: 100%;
    // position: absolute;
    // top: 0;
    // left: 0;
    background-color: #fff;
    opacity: 1;
  }
  .title0 {
    line-height: 80px;
  }
  .title1 {
    color: #5186c2;
    font-size: 14px;
    margin: 20px;
  }
}
.total-result {
  height: calc(100% - 500px);
}
.master-result .radar-contain {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  #radar {
    width: 310px;
    height: 280px;
  }
  .table {
    margin-left: 20px;
  }
}
.vertical-box {
  display: flex;
  align-items: center;
  justify-content: space-around;
  #vertical1 {
    width: 500px;
    height: 500px;
  }
  #vertical2 {
    width: 500px;
    height: 500px;
  }
}

//
</style>